import { WordpressState, RootState } from '@/store/state_models'
import { Module, ActionContext } from 'vuex'
import WordpressService from '../services/WordpressService'

function getInitialData(): WordpressState {
  return {
    productName: 'WORDPRESS_V1',
    resellingProduct: {} as object,
    isOfferingEnabled: false,
    hasFetchedOfferingEnabled: false,
    locationId: undefined,
  }
}

export const wordpress: Module<WordpressState, RootState> = {
  namespaced: true,
  state: getInitialData(),
  getters: {
    getProductName: (state: WordpressState) => {
      return state?.productName
    },
    isWordPressOfferingEnabled: (state: WordpressState) => {
      return {
        isOfferingEnabled: state.isOfferingEnabled,
        hasFetchedOfferingEnabled: state.hasFetchedOfferingEnabled,
      }
    },
  },
  mutations: {
    setOfferingEnabled: (state: WordpressState, payload: { value: boolean; locationId: string }) => {
      state.isOfferingEnabled = payload.value
      state.hasFetchedOfferingEnabled = true
      state.locationId = payload.locationId
    },
    resetOfferingEnabled: (state: WordpressState) => {
      state.isOfferingEnabled = false
      state.hasFetchedOfferingEnabled = false
      state.locationId = undefined
    },
  },
  actions: {
    fetchOfferingEnabled: {
      handler: (context: ActionContext<WordpressState, RootState>, locationId: string) => {
        if (locationId) {
          return new Promise(async (resolve, reject) => {
            // Check if user has wordpress permission
            const userScopes: string[] = context.rootGetters['user/getScopes'] || []
            const hasWordpressPermission =
              userScopes.includes('wordpress.write') || userScopes.includes('wordpress.read')
            if (!hasWordpressPermission) {
              context.commit('setOfferingEnabled', { value: false, locationId })
              return resolve(true) // Return true to continue the flow
            }
            // Check if cache is there for locationId
            if (context.state.hasFetchedOfferingEnabled && context.state.locationId === locationId) {
              return resolve(context.state.isOfferingEnabled)
            }
            try {
              const res = await WordpressService.Payment.getLocationConfig(locationId)
              if (res.data) {
                context.commit('setOfferingEnabled', { value: res.data.offeringEnabled, locationId })
              }
              resolve(res.data)
            } catch (error) {
              reject(error)
            }
          })
        }
      },
    },
    getWordpressDetails: async (context: ActionContext<WordpressState, RootState>, payload: { locationId: string }) => {
      return (await WordpressService.Common.getWordpressByLocId(payload.locationId)).data
    },
    getLocationConfig: async (context: ActionContext<WordpressState, RootState>, payload: { locationId: string }) => {
      return (await WordpressService.Payment.getLocationConfig(payload.locationId)).data
    },
    getCompanyConfig: async (context: ActionContext<WordpressState, RootState>, payload: { companyId: string }) => {
      return (await WordpressService.Payment.getCompanyConfig(payload.companyId)).data
    },
    getCompanySubscriptions: async (
      context: ActionContext<WordpressState, RootState>,
      payload: { companyId: string }
    ) => {
      return (await WordpressService.Payment.getCompanySubscriptions(payload.companyId)).data
    },
    //getProduct: async () => {
    //  return (await WordpressService.Payment.getProduct()).data
    //}
    getProduct: async (context: ActionContext<WordpressState, RootState>) => {
      const companyId = context.rootState?.company.company.id as string
      return (await WordpressService.Payment.getProduct(companyId)).data
    },
    syncAll: async (context: ActionContext<WordpressState, RootState>, locationId: string) => {
      // Reset the state if location has changed
      if (context.state.locationId && context.state.locationId !== locationId) {
        context.commit('resetOfferingEnabled')
      }
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<WordpressState, RootState>) => {
        context.commit('resetOfferingEnabled')
      },
    },
  },
}
